export default __webpack_public_path__ + "static/media/GeorgePortfolio.a73efe20.png";